import { Link } from 'react-router-dom';
import ContactForm from './form/ContactForm';

export default function Contact() {
    return (
        <>
            <div className="contact-hero-section logo-light">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-7 col-lg-7">
                            <div
                                className="contact-hero-content"
                                data-aos="fade-up"
                                data-aos-delay={300}
                                data-aos-duration={1000}
                            >
                                <h2>Wij helpen je graag</h2>
                                <h3>Laten we samenwerken!</h3>
                                <p>
                                    <span>Bandwerk merkenbouwers</span>
                                    Neonstraat 3a <br />
                                    7463 PE Rijssen
                                </p>
                                <p>
                                    0548 - 54 26 72 <br />
                                    info@bandwerk.nl
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-5 mt-md-30 mt-xs-30">
                            <div
                                className="contact-thumb text-center text-lg-end"
                                data-aos="fade-up"
                                data-aos-delay={400}
                                data-aos-duration={1000}
                            >
                                <img src="assets/img/thumb/c-thumb-1.png" alt="thumb" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="contact-area pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6">
                            <div
                                className="content-content"
                                data-aos="fade-up"
                                data-aos-delay={300}
                                data-aos-duration={1000}
                            >
                                <h2>Wat kunnen wij voor jou doen?</h2>
                                <p>
                                    Vertrouw op onze vaardigheden en laat jouw bedrijf, zowel online als offline groeien
                                    door inzet van de nieuwste technologieën.
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 mt-md-50 mt-xs-50">
                            <div
                                className="contact-form"
                                data-aos="fade-up"
                                data-aos-delay={400}
                                data-aos-duration={1000}
                            >
                                <ContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
